<template>
  <section class="contactSection" v-for="contactItems in data.items">
    <h2 v-text="contactItems.title" />
    <div class="contactSection__List">
      <div class="contactSection__Item" v-for="item in contactItems.items">
        <h3 v-text="item.title" />
        <div class="richText" v-html="item.description" />
      </div>
    </div>
  </section>
</template>

<script setup>
	defineProps({
		data: {},
	});
</script>

<style lang="scss">
	@import url('@/assets/styles/components/_contacts.scss');
</style>
